import { defineMessages } from 'react-intl';

export default defineMessages({
  uploadDate: {
    id: 'common.select.uploadDate',
    defaultMessage: 'Data caricamento',
    description: '',
  },
  orderBy:{
    id: 'common.select.orderBy',
    defaultMessage: 'Ordina per',
    description: '',
  },
  title: {
    id: 'common.select.title',
    defaultMessage: 'Titolo',
    description: '',
  },
  fromTheMostRecent: {
    id: 'common.select.fromTheMostRecent',
    defaultMessage: 'Dal più recente',
    description: '',
  },
  fromTheLeastRecent: {
    id: 'common.select.fromTheLeastRecent',
    defaultMessage: 'Dal meno recente',
    description: '',
  },
  selectAll: {
    id: 'common.select.selectAll',
    defaultMessage: 'Seleziona tutti',
    description: 'label for Select All option',
  },
});
